import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'formik';
import { ToggleField, FieldHelp } from '../../../components';
import SignalGroupsLanguageSection from './SignalGroupsLanguageSection';
import SignalContactsSection from './SignalContactsSection';

function SignalIntakeForm() {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col space-y-6">
            <div className="flex flex-col lg:flex-row space-y-6 lg:space-y-0 space-x-0 lg:space-x-12">
                <div className="flex-1">
                    <h2 className="mt-4 mb-1 text-base font-semibold leadin text-lg text-gray-900 dark:text-gray-100 inline-flex items-center gap-1">
                        {t('settings.signal_intake')}
                        <FieldHelp content={t('settings.help.signal_intake') || ''} />
                    </h2>
                    <p className="text-sm text-gray-500 dark:text-gray-400">
                        {t('settings.signal_intake_desc')}
                    </p>
                    <div className="mt-5">
                        <div className="mt-2 flex space-between">
                            <label htmlFor="enable_signal_intake" className="flex-1 text-sm font-medium leading-6 text-gray-900 dark:text-gray-100">
                                {t('settings.enable_signal_intake')}
                            </label>
                            <ToggleField name="signal_intake.enabled" className="inline" />
                        </div>
                    </div>
                    <div className="mt-5">
                        <label htmlFor="reaction_emoji" className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-100">
                            {t('settings.signal_intake_reaction_emoji')}
                        </label>
                        <div className="mt-2">
                            <Field
                                type="text"
                                id="reaction_emoji"
                                name="signal_intake.reaction_emoji"
                                className="block w-full max-w-xs rounded-md border-0 py-1.5 text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                placeholder="🎟"
                            />
                        </div>
                        <small>{t('settings.signal_intake_reaction_emoji_desc')}</small>
                    </div>
                    <div className="mt-5">
                        <label htmlFor="message_retention_days" className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-100">
                            {t('settings.signal_intake_message_retention_days')}
                        </label>
                        <div className="mt-2">
                            <Field
                                type="number"
                                min="1"
                                step="1"
                                id="message_retention_days"
                                name="signal_intake.message_retention_days"
                                className="block w-full max-w-xs rounded-md border-0 py-1.5 text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            />
                        </div>
                        <small>{t('settings.signal_intake_message_retention_days_desc')}</small>
                    </div>
                </div>
            </div>

            <SignalGroupsLanguageSection />
            <SignalContactsSection />
        </div>
    );
}

export default SignalIntakeForm;
